<template>
    <img src="https://static.supsis.live/common/image/app_store.svg" alt="App Store" />
</template>

<script>
export default {
    name: "AppStoreIcon",
};
</script>
